import get from 'lodash/get';

const getArrivedFromExternalSite = (referer, hostName, environment) => {
    if (!referer) {
        return true;
    }

    let refererBase = referer.split('?')[0].split('#')[0];

    // For local and selenium testing, allow pdp-to-pdp link within
    // the same local/testing environment to qualify as on-site traffic
    const isLocalhostInReferer =
        process.env.NODE_ENV === 'development' && refererBase.indexOf('localhost:8080') > -1;
    const isLoadBalancerInReferer =
        (environment === 'test' || environment === 'stage') &&
        refererBase.indexOf(`${environment}.aws.away.black`) > -1;
    const isHostNameInReferer = refererBase.indexOf(hostName) > -1;
    const isHomeawayInReferer = refererBase.indexOf('homeaway') > -1;
    const arrivedFromExternalSite =
        !isLocalhostInReferer &&
        !isLoadBalancerInReferer &&
        !isHostNameInReferer &&
        !isHomeawayInReferer;

    return arrivedFromExternalSite;
};

const getArrivedFromEmail = (queryParams) => {
    const UTM_MEDIUM = 'email';
    const UTM_SOURCE = 'SYS';
    return (
        get(queryParams, 'utm_medium') === UTM_MEDIUM &&
        get(queryParams, 'utm_source') === UTM_SOURCE
    );
};

const getArrivedFromFacebook = (queryParams) => {
    const UTM_MEDIUM = 'display';
    const UTM_SOURCE = 'facebook';
    return (
        get(queryParams, 'utm_medium') === UTM_MEDIUM &&
        get(queryParams, 'utm_source') === UTM_SOURCE
    );
};

const getCookiedGeoString = (cookies) => {
    const keywords = get(cookies, 'ha-state-prst.lbsKeywords');
    return keywords && keywords.split('+').join(' ');
};

const getHasCookiedGeoString = (cookies) => {
    return !!getCookiedGeoString(cookies);
};

const getLocationIsWithinRecentGeoSearch = (preferredLocation, cookies) => {
    const cookiedGeoString = getCookiedGeoString(cookies);
    const location = get(preferredLocation, 'name.full');
    return !!cookiedGeoString && cookiedGeoString.includes(location);
};

export {
    getArrivedFromExternalSite,
    getArrivedFromEmail,
    getArrivedFromFacebook,
    getCookiedGeoString,
    getHasCookiedGeoString,
    getLocationIsWithinRecentGeoSearch
};
